var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var Direction;
(function (Direction) {
    Direction["asc"] = "asc";
    Direction["desc"] = "desc";
})(Direction || (Direction = {}));
var ItemsQuery = /** @class */ (function () {
    function ItemsQuery(page, perPage, sortFields) {
        this.page = page;
        this.perPage = perPage;
        this.sortFields = sortFields;
    }
    Object.defineProperty(ItemsQuery.prototype, "searchParams", {
        get: function () {
            return new URLSearchParams(__spreadArray([
                ['page', String(this.page)],
                ['perPage', String(this.perPage)]
            ], this.sortFields.map(function (sortField) { return ['sort', "".concat(sortField.property, ",").concat(sortField.direction)]; }), true));
        },
        enumerable: false,
        configurable: true
    });
    return ItemsQuery;
}());
export { ItemsQuery };
